export default __webpack_public_path__ + "static/media/TL02.1.bc8d5e6f.mp3";